module.exports = __webpack_public_path__ + "static/media/splash-screen.844edfdb.jpg";